import React, { Component } from "react";
import { Card, CardBody, Progress, Button, ModalBody, Modal, ModalFooter} from "reactstrap";
import NotificationSystem from "react-notification-system";
import AirlineWalletPanel from "./wallets-panel";
import { apiActions, alertActions, commonActions, modalActions } from "../../_actions";
import { appConstants, alertConstants } from "../../_constants";
import { appHelpers, store } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import { connect } from "react-redux";
import PageSuccessMessage from "../utils/pageSuccess";
import { commonService } from "../../_services";
import ViewHeader from "./view-header";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

const generateNotes = [
  { label: "Credit Note", value: true },
  { label: "Debit Note", value: false }
];

class AirlineWallets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      airline: [],
      AirlineId: "",
      startDate: new Date(),
      endDate: new Date(),
      selectValue: { label: "Credit Note", value: "Credit" },
      Amount: 0,
      selectedGenerate: true,
      Comments: "",
      modal: false,
      modalClass: "",
      isCredit: true,
      UserId: null,
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      AirlineCode: "",
      CreateAirlineWalletEntityTypeId: null,
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentWillReceiveProps = function(nextProps) {
    const { alert } = nextProps;
    const { modal, entities } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass
        });
        this.resetForm();
      }
    }

    if (entities) {
      this.setEntityTypes(entities);      
    }
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { airlines, entities, authentication } = reduxState;
    const { dispatch } = this.props;

    if (airlines) {
      this.setState({ airlines: airlines.Results });
    } else {
      this.fetchAirlines();
    }

    if (authentication) {
      if (authentication.user !== undefined) {
          this.setState({
              UserId: authentication.user.userId
          });
      }
  }

    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }
  }

  setEntityTypes = entities => {
    let CreateAirlineWalletEntityTypeId;
    entities.forEach(entity => {
      if (entity.EntityType === appConstants.APP_ENTITIES.CREATE_AIRLINE_WALLET) {
        CreateAirlineWalletEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ CreateAirlineWalletEntityTypeId });
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  createMakerChecker = payload => {
    const {dispatch} = this.props;
    const{
       CreateAirlineWalletEntityTypeId
    }= this.state;
    const { authentication } = store.getState();

    /* Maker checker */
    let payloadTemplate = {
      Airline: this.interpretAirlines(this.state.AirlineCode),
      Amount: this.state.Amount,
      Comment: this.state.Comments,
      ServiceType: this.state.selectedGenerate ? "Credit" : "Debit"
    };    

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${appConstants.PAS_URL}/api/AirlineWallet/CreateWalletFID`,
      EntityTypeId: CreateAirlineWalletEntityTypeId,
      CreatedBy: authentication.user.userName,
    };
    dispatch(apiActions.startRequest());

    commonService.createMakerChecker(makerCheckerPayload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = "Airline wallet created, awaiting approval"
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  }

  interpretAirlines(airlineId) {
    const { Results } = this.props.airlinesCarriers;
    if (Results) {
      const airlineName = Results.find(airline => airline.Id === airlineId);
      if (airlineName) return airlineName.Name;
    }
  }

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      AirlineCode: "",
      Comments: "",
      Amount:0,
      selectedGenerate: null,
    });
    this.resetError();
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    // this.resetError();
    if (this.validateInput()) {
      this.toggle();
    }
  };

  processSubmit = () => {
    let {  AirlineId} = this.state;
    // const userRole = appHelpers.getActiveUser().AviRole;
    const { authentication } = store.getState();

    let payload = {
      AirlineId: this.state.AirlineCode,
      Amount: this.state.Amount,
      Comment: this.state.Comments,
      IsCredit: this.state.selectedGenerate ? true : false,
      userid: authentication.user.userId,
      username: authentication.user.userName,
    };
    if (AirlineId) {
      payload.Id = AirlineId;
    }

      this.createMakerChecker(payload);
    
  };

  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch, airlinesCarriers } = this.props;
    if (!airlinesCarriers) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        let { airlinesCarriers } = this.props;
        this.setState({ airlines: airlinesCarriers.Results });
        dispatch(apiActions.endRequest());
      }).catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.AirlineCode === '') {
      _errs_['AirlineCode'] = 'Please select airline';
      formValid = false;
    }

    if (this.state.Amount === '' ) {
      _errs_['Amount'] = 'Please enter Amount';
      formValid = false;
    }

    if (this.state.Amount === 0) {
      _errs_['Amount'] = 'Amount must be greater than Zero';
      formValid = false;
    }

    if (this.state.Comments === '') {
      _errs_['Comments'] = 'Please enter comment';
      formValid = false;
    }
    if (this.state.selectedGenerate === null) {
      _errs_['selectValue'] = 'Please select a note';
      formValid = false;
    }
    this.setState({ componentErrorMessages: _errs_, errorMessage: false });
    return formValid;
  };

 

  handleSelectChange = (payload, attribute) => {    
    let currState = this.state;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    currState[attribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
    if (!payload) {
      currState[attribute] = '';
    }
    else if (attribute === 'selectedGenerate') {      
      currState[attribute] = payload.value
  }
    else  {
      currState[attribute] = payload.Id;
    }
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });    
  };

  render() {
    // let modalResponse = this.renderPageResponse();
    const { requesting, pageRequesting } = this.props;
    const { AirlineCode, componentErrorMessages, airlines, contentError, walletBalance, Amount, Comments, selectedGenerate} = this.state;

    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {(pageRequesting || requesting) &&
              !pageRequesting && (
                <Progress
                  striped
                  animated
                  color="success"
                  value={100}
                  className="mb-2"
                />
              )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}


            {/*Display component content when Data is gotten from API*/}
            {!contentError &&
              !pageRequesting && (
                <CardBody>
                  <h6 className="mb-0 text-uppercase pull-left">
                    Airline Panel
                                  </h6>
                  <div className="clearfis">&nbsp;</div>
                  <AirlineWalletPanel
                    generateNotes={generateNotes}
                    AirlineCode={AirlineCode}
                    handleSelectChange={this.handleSelectChange}
                    componentErrorMessages={componentErrorMessages}
                    airlines={airlines}
                    selectedGenerate={selectedGenerate}
                    onGenerateValueChange={this.handleSelectChange}
                    requesting={requesting}
                    Amount={Amount}
                    onSubmit={this.handleSubmit}
                    handleChange={this.handleChange}
                    Comments={Comments}
                    startDateChange={startDate => this.setState({ startDate })}
                    endDateChange={endDate => this.setState({ endDate })}
                  />
                  <CardBody>
                    {!requesting &&
                      walletBalance === null && (
                        <PageEmptyContent message={walletBalance} />
                      )}

                    {!requesting && !contentError && walletBalance &&
                      <PageSuccessMessage successMessage={"Wallet Balance Search Successfully"} />
                    }
                    {requesting && <div></div>}

                    <Modal
                    width={"100px"}
                    isOpen={this.state.modal}
                    toggle={this.handleSubmit}
                    className={this.state.modalClass}
                    >
                      {selectedGenerate === true ?
                      <ModalBody>
                        <p className="text-center"> Are you sure you want to Generate Credit Note?</p>
                      </ModalBody>:

                      <ModalBody>
                      <p className="text-center"> Are you sure you want to Generate Debit Note?</p>
                    </ModalBody>}
                      <ModalFooter>
                      <Button className="btn-avi-primary" disabled={requesting} onClick={this.processSubmit}>
                        {" "}
                        Yes{" "}
                      </Button>{" "}
                      <Button color="secondary" onClick={this.toggle}>
                        No
                      </Button>
                    </ModalFooter>
                    </Modal>
                  </CardBody>
                </CardBody>
              )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { loggingIn, user } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { alert, manifestReports, modal , entities, airlines, airlinesCarriers} = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    alert,
    modal,
    manifestReports,
    entities,
    airlines,
    airlinesCarriers,
    user
  };
}

export default connect(mapStateToProps)(AirlineWallets);


// WEBPACK FOOTER //
// ./src/views/airline-wallet/index.js